import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LoggerService } from '@app/services/logger.service';
import { Permission } from '@app/services/perm-helper.service';
import { HasPermsDirective } from '@app/shared/directives/has-perms.directive';
import { TranslateModule } from '@ngx-translate/core';
import { SignalRFacade } from '@ra-state';
import { AuthService } from '@rockwell-automation-inc/service';
import { tap } from 'rxjs';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],

  imports: [AsyncPipe, CommonModule, RouterLink, HasPermsDirective, TranslateModule],
})
export class HomeComponent {
  private readonly authService = inject(AuthService);
  private readonly signalRFacade = inject(SignalRFacade);

  readonly Permission = Permission;
  emailInputValue: string = '';
  tenantId: string = '';
  userInfo$ = this.authService.user$;

  logger = inject(LoggerService).withContext(HomeComponent);

  isHubConnected$ = this.signalRFacade.isHubConnected$.pipe(
    tap((connState) => this.logger.log('Hub Connection State: ', connState)),
  );
}
